import React from 'react';
import { StarIcon } from 'lucide-react';
type Testimonial = {
  quote: string;
  author: string;
  role?: string;
  avatar?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  subtitle?: string;
  background?: 'white' | 'light';
};

/** Renders real buyer reviews only — returns nothing while the list is empty. */
export function Testimonials({
  testimonials,
  title = 'What coaches are saying',
  subtitle,
  background = 'white'
}: TestimonialsProps) {
  if (testimonials.length === 0) return null;
  const bg = background === 'white' ? 'bg-white' : 'bg-light';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-306" data-mp="2x007381rtf1h">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-307" data-mp="2s1qbiwc4wcfc">
        <div className="text-center" data-id="element-308" data-mp="2s3jhsaiu4umt">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-court" data-id="element-309" data-mp="v96kw1xa1zki">
            Coach to coach
          </p>
          <h2 className="mt-3 font-display font-bold text-ink text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-310" data-mp="qbetd90jofgu">
            {title}
          </h2>
          {subtitle && <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-311" data-mp="m5kkcjovulab">{subtitle}</p>}
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-312" data-mp="78k3xcc56cr5">
          {testimonials.map((item, i) => <figure key={i} className="rounded-2xl border border-line bg-white p-5 shadow-card" data-id="element-313" data-mp="c7mxo0mo8wjt" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-314" data-mp="zxr0i5s1cs9r">
                {item.avatar ? <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-line" data-id="element-315" data-mp="14uhgkt3ubnv6" /> : <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-court text-[13px] font-bold text-white" aria-hidden="true" data-id="element-316" data-mp="1itz99jk9bl9t">
                    {item.author.split(/\s+/).map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'BC'}
                  </span>}
                <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-317" data-mp="1jhg4wf7ei25o">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-shuttle text-shuttle" aria-hidden="true" data-id="element-318" data-mp="1el7v7hbz315w" />)}
                </span>
              </div>
              <blockquote className="mt-3 text-sm italic text-ink" data-id="element-319" data-mp="14u4r06nqy62e">{item.quote}</blockquote>
              <figcaption className="mt-4 text-xs text-ink-soft" data-id="element-320" data-mp="10t1e9t0zwq5e">
                <span className="block text-[13px] font-bold not-italic text-ink" data-id="element-321" data-mp="vsdmv68uu7an">{item.author}</span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}